import {
  getState,
  Selectors,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {PayloadAction} from '@reduxjs/toolkit';
import {Platform} from 'react-native';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {
  deletePayment,
  getAllPayments,
  PaymentIntegrationDeleteOptions,
  PaymentIntegrationSaveOptions,
  savePayment,
} from 'services/api/paymentintegration';
import {PaymentsActions} from './payments.reducer';
import {APIPropCode} from 'models/FreedomPay';
import {getAuthTokenSaga} from 'utils/getAuthTokenSaga';

export function* getPISToken() {
  const isRaaSToken = yield call(getState, Selectors.isRaaSTokenSelector);
  let token;

  if (!isRaaSToken) {
    token = yield call(getState, Selectors.webviewPatronTokenSelector);
    if (!token) {
      throw 'token is undefined';
    }
    return token;
  }

  token = yield call(getAuthTokenSaga);

  return token;
}

export function* handleGetAllPayments() {
  try {
    const token = yield call(getPISToken);
    const response = yield call(getAllPayments, token);

    if (response.data?.header.resultCode !== 'WCS0000') {
      throw 'Error getting the payments';
    }
    const paymentsList = response.data?.body?.payments;
    yield put(PaymentsActions.getAllCardsSuccess(paymentsList));
  } catch (e: any) {
    yield put(PaymentsActions.getAllCardsFailure());
  }
}

export function* handleSaveCard(
  action: PayloadAction<PaymentIntegrationSaveOptions>
) {
  try {
    const token = yield call(getPISToken);

    const response = yield call(savePayment, {
      token,
      propCode: APIPropCode,
      ...action.payload,
    });

    const resultCode = response.data?.header?.resultCode;
    const resultMessage = response.data?.header?.resultMessage;

    if (resultCode !== 'WCS0000') {
      yield put(
        PaymentsActions.saveCardFailure({
          resultCode: resultCode || '',
          resultMessage: resultMessage || '',
        })
      );
      return;
    }

    yield put(PaymentsActions.saveCardSuccess(action.payload));
  } catch (e) {
    yield put(PaymentsActions.saveCardFailure());
  }
}

export function* handleDeleteCard(
  action: PayloadAction<PaymentIntegrationDeleteOptions>
) {
  try {
    const token = yield call(getPISToken);

    const response = yield call(deletePayment, {token, ...action.payload});

    if (response.data?.header?.resultCode !== 'WCS0000') {
      throw 'Error deleting the card';
    }

    yield put(PaymentsActions.deleteCardSuccess(action.payload));
  } catch (e) {
    yield put(PaymentsActions.deleteCardFailure());
  }
}

export function* paymentsSagas() {
  yield all([
    takeLatest(PaymentsActions.getAllCards, handleGetAllPayments),
    takeLatest(PaymentsActions.saveCard, handleSaveCard),
    takeLatest(PaymentsActions.deleteCard, handleDeleteCard),
  ]);
}
